<template>
  <TransferVehicle />
</template>
<script>
import TransferVehicle from "@/components/master/transferTariff/TransferVehicle.vue";
export default {
  components: {
    TransferVehicle,
  },
  updated() {
    this.$helper.collapseMenu("selling-tariff");
    this.$helper.setNavigationClass("selling-transfer-link-new");
  },
};
</script>


// WEBPACK FOOTER //
// src/components/master/sellingTariff/TransferClassList.vue